export default [
  {
    date: 1542722752644,
    row: 8,
    col: 8,
    squares: [
      [2, 4, "#434343"],
      [2, 5, "#434343"],
      [3, 3, "#434343"],
      [3, 6, "#434343"],
      [4, 2, "#434343"],
      [4, 3, "#434343"],
      [4, 4, "#434343"],
      [4, 5, "#434343"],
      [4, 6, "#434343"],
      [4, 7, "#434343"],
      [5, 2, "#434343"],
      [6, 2, "#434343"],
      [7, 2, "#434343"],
      [8, 2, "#434343"],
      [5, 7, "#434343"],
      [6, 7, "#434343"],
      [7, 7, "#434343"],
      [8, 7, "#434343"],
      [7, 4, "#434343"],
      [7, 5, "#434343"],
      [8, 5, "#434343"],
      [8, 4, "#434343"],
    ],
  },
  {
    date: 1542722794973,
    row: 8,
    col: 8,
    squares: [
      [2, 8, "#666666"],
      [2, 6, "#666666"],
      [2, 4, "#666666"],
      [2, 2, "#666666"],
      [3, 2, "#666666"],
      [3, 3, "#666666"],
      [3, 4, "#666666"],
      [3, 5, "#666666"],
      [3, 6, "#666666"],
      [3, 7, "#666666"],
      [3, 8, "#666666"],
      [4, 8, "#666666"],
      [5, 8, "#666666"],
      [6, 8, "#666666"],
      [7, 8, "#666666"],
      [8, 8, "#666666"],
      [8, 6, "#666666"],
      [7, 6, "#666666"],
      [6, 6, "#666666"],
      [6, 5, "#666666"],
      [6, 4, "#666666"],
      [7, 4, "#666666"],
      [8, 4, "#666666"],
      [8, 2, "#666666"],
      [7, 2, "#666666"],
      [6, 2, "#666666"],
      [5, 2, "#666666"],
      [4, 2, "#666666"],
    ],
  },
  {
    date: 1542722942072,
    row: 8,
    col: 8,
    squares: [
      [1, 4, "#FF9900"],
      [1, 5, "#FF9900"],
      [2, 3, "#FF9900"],
      [2, 6, "#FF9900"],
      [3, 2, "#FF9900"],
      [3, 7, "#FF9900"],
      [4, 8, "#FF9900"],
      [5, 8, "#FF9900"],
      [6, 7, "#FF9900"],
      [7, 6, "#FF9900"],
      [8, 5, "#FF9900"],
      [8, 4, "#FF9900"],
      [7, 3, "#FF9900"],
      [6, 2, "#FF9900"],
      [5, 1, "#FF9900"],
      [4, 1, "#FF9900"],
      [4, 4, "#FF9900"],
      [5, 5, "#FF9900"],
    ],
  },
  {
    date: 1542722982350,
    row: 8,
    col: 8,
    squares: [
      [8, 2, "#FF00FF"],
      [7, 2, "#FF00FF"],
      [6, 2, "#FF00FF"],
      [5, 2, "#FF00FF"],
      [4, 2, "#FF00FF"],
      [3, 2, "#FF00FF"],
      [2, 2, "#FF00FF"],
      [2, 3, "#FF00FF"],
      [2, 4, "#FF00FF"],
      [2, 5, "#FF00FF"],
      [3, 5, "#FF00FF"],
      [4, 5, "#FF00FF"],
      [5, 5, "#FF00FF"],
      [6, 5, "#FF00FF"],
      [7, 5, "#FF00FF"],
      [8, 5, "#FF00FF"],
      [8, 6, "#FF00FF"],
      [8, 7, "#FF00FF"],
      [8, 8, "#FF00FF"],
      [7, 8, "#FF00FF"],
      [6, 8, "#FF00FF"],
      [5, 8, "#FF00FF"],
      [4, 8, "#FF00FF"],
      [3, 8, "#FF00FF"],
      [2, 8, "#FF00FF"],
    ],
  },
  {
    date: 1542723016007,
    row: 8,
    col: 8,
    squares: [
      [1, 1, "#5CB85C"],
      [1, 2, "#5CB85C"],
      [1, 3, "#5CB85C"],
      [1, 4, "#5CB85C"],
      [1, 5, "#5CB85C"],
      [1, 6, "#5CB85C"],
      [1, 7, "#5CB85C"],
      [1, 8, "#5CB85C"],
      [2, 8, "#5CB85C"],
      [3, 8, "#5CB85C"],
      [4, 8, "#5CB85C"],
      [5, 8, "#5CB85C"],
      [6, 8, "#5CB85C"],
      [7, 8, "#5CB85C"],
      [8, 8, "#5CB85C"],
      [8, 7, "#5CB85C"],
      [8, 6, "#5CB85C"],
      [8, 5, "#5CB85C"],
      [8, 4, "#5CB85C"],
      [8, 3, "#5CB85C"],
      [7, 3, "#5CB85C"],
      [6, 3, "#5CB85C"],
      [5, 3, "#5CB85C"],
      [4, 3, "#5CB85C"],
      [4, 4, "#5CB85C"],
      [4, 5, "#5CB85C"],
      [5, 5, "#5CB85C"],
      [6, 5, "#5CB85C"],
    ],
  },
  {
    date: 1542723041534,
    row: 8,
    col: 8,
    squares: [
      [1, 1, "#FF0000"],
      [2, 2, "#FF0000"],
      [3, 3, "#FF0000"],
      [3, 6, "#FF0000"],
      [2, 7, "#FF0000"],
      [1, 8, "#FF0000"],
      [4, 1, "#FF0000"],
      [5, 1, "#FF0000"],
      [6, 3, "#FF0000"],
      [7, 2, "#FF0000"],
      [8, 1, "#FF0000"],
      [6, 6, "#FF0000"],
      [7, 7, "#FF0000"],
      [8, 8, "#FF0000"],
      [4, 8, "#FF0000"],
      [5, 8, "#FF0000"],
    ],
  },
  {
    date: 1542723132423,
    row: 8,
    col: 8,
    squares: [
      [1, 2, "#666666"],
      [1, 3, "#666666"],
      [1, 6, "#666666"],
      [1, 7, "#666666"],
      [2, 4, "#666666"],
      [2, 5, "#666666"],
      [3, 2, "#666666"],
      [3, 3, "#666666"],
      [3, 6, "#666666"],
      [3, 7, "#666666"],
      [4, 4, "#666666"],
      [4, 5, "#666666"],
      [5, 5, "#666666"],
      [5, 4, "#666666"],
      [6, 2, "#666666"],
      [6, 3, "#666666"],
      [6, 6, "#666666"],
      [6, 7, "#666666"],
      [7, 4, "#666666"],
      [7, 5, "#666666"],
      [8, 2, "#666666"],
      [8, 3, "#666666"],
      [8, 6, "#666666"],
      [8, 7, "#666666"],
    ],
  },
  {
    date: 1542723162094,
    row: 8,
    col: 8,
    squares: [
      [1, 3, "#666666"],
      [2, 4, "#666666"],
      [2, 5, "#666666"],
      [1, 6, "#666666"],
      [3, 8, "#666666"],
      [4, 7, "#666666"],
      [5, 7, "#666666"],
      [6, 8, "#666666"],
      [4, 4, "#666666"],
      [4, 5, "#666666"],
      [5, 5, "#666666"],
      [5, 4, "#666666"],
      [3, 1, "#666666"],
      [4, 2, "#666666"],
      [5, 2, "#666666"],
      [6, 1, "#666666"],
      [8, 3, "#666666"],
      [7, 4, "#666666"],
      [7, 5, "#666666"],
      [8, 6, "#666666"],
    ],
  },
];
